<template>
    <v-ons-page>
        <!-- Toolbar -->
        <ons-toolbar class="main-toolbar">
            <div class="center brand-toobar">
                <img src="/logo_v2.png" class="logo">
            </div>
            <div class="left">
                <a v-on:click="$router.go(-1)">
                    <svg class="icon icon-fit icon-arrow-back" aria-hidden="true"></svg>
                </a>
            </div>
        </ons-toolbar>

        <div class="content">
            <v-ons-progress-bar v-if="show_loading" indeterminate></v-ons-progress-bar>

            <template v-if="orders != null">

                <div class="content-inner">

                    <div class="main-header">My orders</div>
                    <div class="sub-header-lite">{{ orders.length }} orders</div>

                    <v-ons-list class="section-h" data-test-id="cnt-orders">
                        <v-ons-list-item
                                v-for="order in orders"
                                v-bind:key="order.id"
                                v-on:click="$router.push({ name: 'Order', params: { sales_id: order.id } })"
                                modifier="chevron" tapable>
                            <div class="center">
                                <div>
                                    <span class="order-header">Order #{{ order.order_ref}}</span>
                                    <br>
                                    <span>{{ order.outlet.store_display_name }}</span>
                                    <br>
                                    <span class="">{{ order.fulfilment_type }}</span>
                                </div>
                            </div>
                            <div class="right">
                                <span class="order-details-container">
                                    <span class="item-price-text">{{ filters.money(order.sales_details.total, true, order.currency_symbol) }}</span>
                                    <br>
                                    <span class="order-date">{{ filters.dateFormat(order.sales_date_time, 'DATE') }}</span>
                                </span>
                            </div>
                        </v-ons-list-item>
                    </v-ons-list>

                </div>
            </template>
        </div>

    </v-ons-page>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    export default {
        data () {
            return {
                app: this.$root.$data.app,
                orders: null,
            }
        },

        mounted(){
            
            const data = {}
            if (this.embed.enabled)
                data.order_outlet = this.outlet.slug

            this.app.http.get('orders', data)
                .then(response => {
                    this.app.analytics.track('viewOrders')

                    this.orders = response.data.orders
                })
                .catch(error => {
                    this.$ons.notification.alert(
                        this.app.getResponseErrorMessage(error),
                        { title: 'Unable to display orders' },
                    )
                })
        },

        methods: {

        },

        computed: {
            ...mapGetters([
                'embed',
                'outlet',
            ]),

            show_loading: function(){
                return this.orders == null
            },
        },
    }
</script>

<style scoped>

    .list-item--chevron:before {
        border-color: #1A1824;
    }

    .order-details-container {
        text-align: right;
    }

    .order-date {
        font-size: 14px;
        color: #181D1E;
        opacity: 0.5;
    }

    .order-header{
        font-weight: bold;
        color: #181D1E;
    }

</style> 


// WEBPACK FOOTER //
// src/js/components/user/orders.vue